<template>
  <div>
    <div class="manage--main">
      <button
        class="btn-tast btn-next-1"
        v-if="mobile"
        v-on:click="back()"
      ></button>
      <div class="header-manage">
        <div class="user-name" id="clm" v-if="mobile && !menu">
          <template v-if="courseName != null && courseName.search('@') !== -1">{{
            courseName
          }}</template>
          <template v-if="courseName != null && courseName.search('@') == -1">{{
            courseName
          }}</template>
        </div>
        <div class="user-namesss" v-if="mobile && menu">
          <template v-if="courseName != null && courseName.search('@') !== -1">{{
            courseName
          }}</template>
          <template v-if="courseName != null && courseName.search('@') == -1">{{
            courseName
          }}</template>
        </div>
        <div class="icon-img-right" @click="showUser()">
          <template v-if="menu"
            ><img src="../../../static/images/icon-cb-trang.png"
          /></template>
          <template v-else
            ><img src="../../../static/images/mucluc-trang.png"
          /></template>
        </div>
      </div>
      <!-- menu -->
      <leftSeflCourse
        v-if="showMenu"
        :data="{ dataLeftSeflCourse: data, dataBegin: dataBegin }"
        v-on:changeItem="changeItem($event)"
      ></leftSeflCourse>
      <!-- Nội dung danh sách các khoá học -->
      <contentSeflCourse
        v-if="showContent"
        :data="{
          dataContentSeflCourse: data,
          dataBegin: dataBegin,
          courseName: courseName,
          dataTypeCatalog: dataTypeCatalog
        }"
        v-on:changeItem="changeItem($event)"
      ></contentSeflCourse>
    </div>
    <loading class="loading--lesson" :showLoading="!isLoadData" />
  </div>
</template>

<script>
import leftSeflCourse from "@/components/defineSelfCourse/content/leftSelfCourse";
import contentSeflCourse from "@/components/defineSelfCourse/content/contentSelfCourse";
import loading from "@/components/loading/loading";
export default {
  data() {
    return {
      data: null,
      menu: true,
      courseName: this.$t("new.title130"),
      dataBegin: {
        type: "1cs",
        catalogId: null
      },
      showContent: true,
      showMenu: true,
      dataTypeCatalog: {},
      isLoadData: true
    };
  },
  components: {
    leftSeflCourse,
    contentSeflCourse,
    loading
  },
  computed: {
    mobile() {
      return this.$store.getters["header/mobile"];
    }
  },
  created() {},
  async mounted() {
    this.data = await this.getAllListCatalog();
    this.init();
  },
  watch: {},
  methods: {
    getAllListCatalog() {
      this.isLoadData = false;
      return new Promise((resolve, reject) => {
        this.$api
          .post("/evaluate/getAllCatalog", {
            languageType: this.$lang(),
            itemcount: {
              numberCatalog: null,
              numberCouseHot: null,
              numberCourseNew: null,
              numberEncourageStudyArt: null
            },
            domainName: window.location.host
          })
          .then(response => {
            this.isLoadData = true;
            resolve(response.data);
          })
          .catch(err => {
            this.isLoadData = true;
            reject(err.response);
          });
      });
    },
    async init() {
      /// Lấy query để check khi bắt đầu thuộc loại nào
      let type = this.$route.query.type;
      if (type == 1) {
        this.dataBegin.type = "1cs";
        this.courseName = this.$t("new.title130");
      } else if (type == 2) {
        this.dataBegin.type = "2cs";
        this.courseName = this.$t("new.title131");
      } else if (type == 3) {
        this.dataBegin.type = "3cs";
        this.courseName = this.$t("new.title132");
      } else if (type == 4) {
        this.dataBegin.type = "4cs";
        this.dataBegin.catalogId = this.$route.query.catalogId;
        this.data.listCatalog.forEach(value => {
          if (this.dataBegin.catalogId == value.catalogId) {
            this.courseName = value.catalogName;
          }
        });
        this.dataTypeCatalog = await this.getDataTypeCatalog(
          this.dataBegin.catalogId
        );
      }
      /// Load lại trang sau khi kiểm tra xong
      this.showContent = false;
      this.showMenu = false;
      this.$nextTick(() => {
        this.showContent = true;
        this.showMenu = true;
      });
    },
    /// click menu để thay đổi nội dung tương ứng
    changeItem: async function(value) {
      /// Trường hợp là loại 4 thì sẽ load API để gọi data
      if (value.type == 4) {
        this.dataBegin.type = "4cs";
        this.dataBegin.catalogId = value.dataChild.catalogId;
        this.courseName = value.dataChild.catalogName;
        this.dataTypeCatalog = await this.getDataTypeCatalog(
          value.dataChild.catalogId
        );
      } else {
        /// Trường hợp là khác loại 4 sẽ lấy typeId để check data list
        this.dataBegin.type = value.dataChild.id;
        this.courseName = value.dataChild.name;
      }
      this.showContent = false;
      this.$nextTick(() => {
        this.showContent = true;
      });
    },
    /// Load data nếu thuộc loại 4 => Loại danh mục
    getDataTypeCatalog: function(value) {
      this.isLoadData = false;
      return new Promise((resolve, reject) => {
        this.$api
          .post("/evaluate/getCourseByIdCatalog", {
            catalogId: value
          })
          .then(response => {
            this.isLoadData = true;
            resolve(response.data);
          })
          .catch(err => {
            this.isLoadData = true;
            reject(err.response);
          });
      });
    },
    /// Hiển thị menu bên MB
    showUser: function() {
      this.menu = !this.menu;
      document
        .getElementsByTagName("body")
        [this.$CONST.COMMON.NUMBER.ZERO].classList.toggle("show-menu-1");
    },
    /// Quay lại trang index
    back: function() {
      this.$router.push({
        path: "home/index"
      });
    }
  }
};
</script>
<style scoped>
.btn-next-1 {
  z-index: 1001;
  display: none;
}
.user-name {
  margin-left: 50px;
}
.user-namesss {
  font-weight: bold;
  padding: 0 5px;
  text-transform: uppercase;
  font-size: 18px;
  color: #fff;
  margin-left: 50px;
  text-overflow: ellipsis !important;
  overflow: hidden;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/views/defineSelfCourse/selfCourse.vue